// @flow
import React, { Fragment } from 'react'

import Button from '../controls/PrimaryButton'
import styled from 'styled-components'
import Modal from '../FieldSet/Modal'
import ErrorText from '../controls/ErrorText'
import type { OptionType } from '../types'
import Select from '../controls/Select'

const FieldWrapper = styled.div`
  font-size: 14px;
  padding-bottom: 12px;
`

const fieldCommonStyles = `
  width: 100%;
  height: 35px;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 0 15px;
  margin: 0 5px 0 0;
  text-align: left;
`

const TextInput = styled.input`
  ${fieldCommonStyles};
  ${({ hasErrors }: Object) => hasErrors && 'border-color: red;'};
`

const Label = styled.div`
  padding: 6px 3px;
  font-size: 14px;
`

const Spacer = styled.div`
  height: 30px;
`

const t = {
  header: 'Создание нового рекламного кабинета',
  name: 'Название',
  name_placeholder: 'Будет отображаться в списке кабинетов',
  agency_billing_model: 'Кто будет пополнять баланс кабинета',
  create_ad_account: 'Создать кабинет'
}

export type Props = {|
  isOpen: boolean,
  isLoading: boolean,
  name: string,
  agencyBillingModel: number,
  agencyBillingModelOptions: Array<OptionType>,
  nameErrors: Array<string>,
  agencyBillingModelErrors: Array<string>,
  commonErrors: Array<string>,
  onOpen: () => void,
  onClose: () => void,
  onNameChange: (string) => void,
  onAgencyBillingModelChange: (number) => void,
  onPersist: () => void
|}

export default function CreateForm({
  isOpen,
  isLoading,
  name,
  agencyBillingModel,
  agencyBillingModelOptions,
  nameErrors,
  agencyBillingModelErrors,
  commonErrors,
  onOpen,
  onClose,
  onNameChange,
  onAgencyBillingModelChange,
  onPersist
}: Props) {
  return (
    <Fragment>
      <Button small onClick={() => onOpen()}>
        {t.create_ad_account}
      </Button>
      <Modal maxWidth={500} header={t.header} isOpen={isOpen} hideBtn onClose={() => onClose()}>
        <ErrorText errors={commonErrors} />
        <FieldWrapper>
          <Label>{t.name}</Label>
          <TextInput
            className="t-Name"
            placeholder={t.name_placeholder}
            disabled={isLoading}
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
          />
          <ErrorText errors={nameErrors} />
        </FieldWrapper>

        <FieldWrapper>
          <Label>{t.agency_billing_model}</Label>
          <Select
            value={agencyBillingModel}
            options={agencyBillingModelOptions}
            disabled={isLoading}
            onChange={onAgencyBillingModelChange}
          />
          <ErrorText errors={agencyBillingModelErrors} />
        </FieldWrapper>
        <Spacer />

        <Button className="t-Create" onClick={() => onPersist()} disabled={isLoading}>
          {t.create_ad_account}
        </Button>
      </Modal>
    </Fragment>
  )
}
